import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { MuiTheme } from "../styles/MuiDataTableStyle";
import { getNotifications } from "../services/notificationsService";
import { useStateAuthValue } from "../context/AuthState";
import { useToast } from "../context/Toast/ToastProvider";
import { showToast, ToastType } from "../utils/ToastUtil";
import { LoadingModal } from "../components/Modals/LoadingModal";
import { NotificationTable } from "../components/notificationTable";
import { useLocation } from "react-router-dom";
import PageHeader from "../components/PageHeader";

const Notifications = () => {
  const [{ userToken }] = useStateAuthValue();
  const [data, setData] = useState([]);
  const [dataLength, setDataLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const toastDispatch = useToast();
  const displayError = (msg) => showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
  let location = useLocation().search.split('?param=')[1];
  const getNotificationsData = async (params) => {
    const response = await getNotifications(userToken, displayError, params);
    setData(response.notifications);
    setDataLength(response?.notifications?.length)
    setCurrentPage(response?.currentPage);
    setTotalPages(response?.totalPages > 1 && response?.currentPage === 0 ? -1 : response?.totalItems);
  }
  useEffect(() => {
    let params = {}
    params.status = 'ERROR'
    params.meanTypes = ['WHATSAPP', 'EMAIL']
    params.event = location.toUpperCase()
    setLoading(true);
    getNotificationsData(params)
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken]);

  return (
    <ThemeProvider theme={MuiTheme}>
      <div className="users">
        <div className="users-table-container">
          <PageHeader title="Listado de notificationes" />

          <NotificationTable
            data={data}
            getNotificationsData={getNotificationsData}
            setLoading={setLoading}
            totalPages={totalPages}
            setTotalPages={setTotalPages}
            dataLength={dataLength}
            currentPage={currentPage}
            event={location.toUpperCase()}
          />

        </div>
      </div>
      {loading && <LoadingModal />}
    </ThemeProvider>
  );
};

export default Notifications;
